<template>
	<div class="home">
		<spanish 
			v-if="language === 'spanish'"
			@language="changeLanguage"
		></spanish>

		<english 
			v-if="language === 'english'"
			@language="changeLanguage"
		></english>
	</div>
</template>

<script>
import Spanish from './Spanish'
import English from './English'

export default {
	name: 'Home',
	data () {
		return {
			// Language
			language: 'spanish',
		}
	},
	methods: {
		changeLanguage (value) {
			this.language = value
		}
	},
	components: { Spanish, English }
};
</script>

<style lang="scss">
$gray: #e6ddcc;
$pink: #e24a9b;
$white: #ffffff;
$black: #000000;

@font-face {
	font-family: 'Montserrat';
	src: url('../assets/font/Montserrat-Regular.ttf');
}

body {
	position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/Tool.vue